import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import CameraScan from '../pages/CameraScan';

import { StorageKeys } from '../utils/storage';

const URLParamHandler = ({ children }: { children: React.ReactNode }) => {
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const licenseUsageId = params.get('licenseUsageId') || params.get('license_usage_id');
    const licenseKey = params.get('licenseKey') || params.get('license_key');
    const returnUrl = params.get('returnUrl') || params.get('redirectUrl') || params.get('callbackUrl');
    const deviceUserId = params.get('device_user_id');
    const token = params.get('token');

    if (licenseUsageId) localStorage.setItem(StorageKeys.LICENSE_USAGE_ID, licenseUsageId);
    if (licenseKey) localStorage.setItem('licenseKey', licenseKey);
    if (returnUrl) localStorage.setItem('returnUrl', returnUrl);
    if (deviceUserId) localStorage.setItem(StorageKeys.DEVICE_USER_ID, deviceUserId);
    if (token) localStorage.setItem('token', token);
  }, []);

  return <>{children}</>;
};

const App = () => {
  return (
    <Router>
      <URLParamHandler>
        <Routes>
          <Route path="/camera-scan" element={<CameraScan />} />
          <Route path="/" element={<Navigate to="/camera-scan" replace />} />
          <Route path="*" element={<Navigate to="/camera-scan" replace />} />
        </Routes>
      </URLParamHandler>
    </Router>
  );
};



export default App;
